import { Link, useParams, useSearchParams } from "react-router-dom";
import { Page } from "../../components/ui/Page";
import { usePanelPath } from "../../routing";

export function CompletionPage() {
  const [searchParams] = useSearchParams();
  const params = useParams();
  const panelPath = usePanelPath();
  const taskId = params.taskId ?? searchParams.get("taskId") ?? undefined;
  // const taskQuery = useTask(taskId);
  // const panelistQuery = usePanelist();

  // if (taskQuery.isLoading || panelistQuery.isLoading) {
  //   return (
  //     <Page>
  //       <div className="completion-wrap">
  //         <SkeletonBlock count={5} height={44} />
  //       </div>
  //     </Page>
  //   );
  // }

  // if (taskQuery.error || panelistQuery.error || !panelistQuery.data) {
  //   return (
  //     <Page>
  //       <div className="completion-wrap">
  //         <ErrorState
  //           error={taskQuery.error ?? panelistQuery.error}
  //           title="Could not load completion details"
  //         />
  //       </div>
  //     </Page>
  //   );
  // }

  // const panelist = panelistQuery.data;
  // const points = taskQuery.data?.points ?? 0;

  return (
    <Page>
      <div className="completion-wrap">
        <div className="comp-icon">✓</div>
        <h2
          style={{
            color: "var(--primary)",
            fontFamily: "var(--font-h)",
            fontSize: 26,
            fontWeight: 600,
          }}
        >
          Survey submitted!
        </h2>
        <p
          style={{
            color: "var(--sand)",
            fontSize: 14,
            lineHeight: 1.5,
            margin: "6px 0 18px",
          }}
        >
          Thank you. Your response has been received and is being reviewed.
        </p>
        {/* <div className="comp-pts">+{points} pts</div>
        <div className="comp-pts-lbl">pending quality review</div>
        <div className="comp-balance">
          <div className="comp-bal-lbl">Current balance</div>
          <div className="comp-bal-val">
            {panelist.points} pts{" "}
            <span style={{ color: "var(--sand)", fontSize: 14 }}>
              → {panelist.points + points} when approved
            </span>
          </div>
        </div> */}
        <div className="alert alert-info" style={{ textAlign: "left" }}>
          Points are usually credited within 24–48 hours after quality review.
        </div>
        <Link
          className="btn btn-accent btn-full"
          style={{ marginBottom: 10 }}
          to={panelPath("/")}
        >
          Back to dashboard
        </Link>
        <Link className="btn btn-outline btn-full" to={panelPath("/tasks")}>
          View more tasks
        </Link>
      </div>
    </Page>
  );
}
